import { formValueSelector, reduxForm } from 'redux-form'

import { connect } from 'react-redux'
import WizardFooter from './WizardFooter'
import { FORM_NAME } from './shared'
import InitialApplicationChatAssistant from '../AI/AIChatAssistant/InitialApplicationChatAssistant'
import Button from '../Shared/Button'

type WizardFormGoalPageProps = {
  onSubmit: (data: { independent: true }) => void
}

const WizardFormGoalPage = (props: WizardFormGoalPageProps): JSX.Element => {
  const { onSubmit } = props
  const proceedToPlatform = () => {
    onSubmit({
      independent: true,
    })
  }

  return (
    <>
      <div id="new-app-goal-form" className="new-app-form">
        <div className="new-app-goal-settings">
          <InitialApplicationChatAssistant />
        </div>
      </div>
      <WizardFooter>
        <div className="link-classic-builder-container">
          <Button text type="type" onClick={proceedToPlatform}>
            I want to use the classic Builder
          </Button>
        </div>
      </WizardFooter>
    </>
  )
}

function mapStateToProps(state: Record<string, unknown>) {
  const selector = formValueSelector(FORM_NAME)
  const independentValue: unknown = selector(state, 'independent')
  const personaValue: unknown = selector(state, 'persona')
  const establishedValue: unknown = selector(state, 'established')
  const businessNameValue: unknown = selector(state, 'businessName')
  const websiteValue: unknown = selector(state, 'website')
  const typeValue: unknown = selector(state, 'type')
  const usersValue: unknown = selector(state, 'users')
  const descriptionValue: unknown = selector(state, 'description')
  const timelineValue: unknown = selector(state, 'timeline')
  const budgetValue: unknown = selector(state, 'budget')

  return {
    independent:
      typeof independentValue === 'boolean' ? independentValue : null,
    persona: personaValue as string | null,
    established:
      typeof establishedValue === 'boolean' ? establishedValue : null,
    businessName: businessNameValue as string | null,
    website: websiteValue as string | null,
    type: typeValue as string | null,
    users: usersValue as string | null,
    description: descriptionValue as string | null,
    timeline: timelineValue as string | null,
    budget: budgetValue as number | null,
  }
}

export default reduxForm<WizardFormGoalPageProps>({
  form: FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(connect(mapStateToProps)(WizardFormGoalPage))
